// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-d05c5df6]{font-size:20px;line-height:18px}.link[data-v-d05c5df6]{all:unset}", ""]);
// Exports
module.exports = exports;
